export default __webpack_public_path__ + "static/media/vegetarian.706abeb6.svg";